module.exports = {
	"id": "PE",
	"name": "Peru",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.022443,
			"12": null,
			"13": 0.007481,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.022443,
			"19": null,
			"20": 0.037405,
			"21": 0.007481,
			"22": 0.082291,
			"23": 0.022443,
			"24": 0.022443,
			"25": 0.037405,
			"26": 0.059848,
			"27": 0.014962,
			"28": 0.014962,
			"29": 0.067329,
			"30": 0.022443,
			"31": 0.067329,
			"32": 0.022443,
			"33": 0.067329,
			"34": 0.07481,
			"35": 0.044886,
			"36": 0.052367,
			"37": 0.044886,
			"38": 0.07481,
			"39": 0.119696,
			"40": 0.07481,
			"41": 0.059848,
			"42": 0.059848,
			"43": 0.201987,
			"44": 0.179544,
			"45": 0.164582,
			"46": 0.261835,
			"47": 0.239392,
			"48": 0.269316,
			"49": 3.553475,
			"50": 0.486265,
			"51": 1.436352,
			"52": 1.488719,
			"53": 40.973437,
			"54": 11.655398,
			"55": 0.097253,
			"56": 0.022443,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.022443,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.007481,
			"17": 0.007481,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.007481,
			"30": 0.007481,
			"31": 0.014962,
			"32": null,
			"33": 0.007481,
			"34": 0.022443,
			"35": 0.014962,
			"36": 0.014962,
			"37": 0.022443,
			"38": 0.029924,
			"39": 0.029924,
			"40": 0.022443,
			"41": 0.037405,
			"42": 0.029924,
			"43": 0.127177,
			"44": 0.029924,
			"45": 0.07481,
			"46": 0.052367,
			"47": 0.29924,
			"48": 0.231911,
			"49": 2.648274,
			"50": 0.022443,
			"51": 0.007481,
			"52": null,
			"3.5": null,
			"3.6": 0.007481
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.014962,
			"37": 0.022443,
			"38": 0.037405,
			"39": 0.007481,
			"40": 0.29924,
			"41": 0.044886,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": 0.022443,
			"8": 0.067329,
			"9": 0.07481,
			"10": 0.306721,
			"3.1": null,
			"3.2": null,
			"5.1": 0.014962,
			"6.1": null,
			"7.1": 0.007481,
			"9.1": 0.254354
		},
		"ios_saf": {
			"8": 0,
			"10": 1.09130245795,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0294093384679,
			"8.1-8.4": 0.0543325066611,
			"9.0-9.2": 0.0259200949209,
			"9.3": 0.395447601998
		},
		"android": {
			"3": 0,
			"4": 0.031972744186,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00399659302326,
			"4.1": 0.115330255814,
			"4.2-4.3": 0.288325639535,
			"4.4": 0.661150674419,
			"4.4.3-4.4.4": 0.666860093023
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.306884817518,
			"9": 0.115081806569,
			"10": 0.207147251825,
			"11": 1.47304712409,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0777942774331,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00216095215092
		},
		"edge": {
			"12": 0.067329,
			"13": 0.209468,
			"14": 0.336645
		},
		"ie_mob": {
			"10": 0.170301915493,
			"11": 0.693372084507
		},
		"bb": {
			"7": 0.0144785,
			"10": null
		},
		"samsung": {
			"0": 0.898926
		},
		"and_uc": {
			"0": 0.178778
		},
		"op_mini": {
			"0": 1.04810877042
		},
		"and_chr": {
			"0": 21.110834
		},
		"and_ff": {
			"0": 0.042806
		}
	},
	"total": 97.5265155
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PE.json
 ** module id = 618
 ** module chunks = 0
 **/